<div
  *ngIf='componentReady'
  [formGroup]='inputForm'
  class='ChangeAccountPasswordDialog container'>
  <div class='row'>
    <div class='col col-12 d-flex flex-column'>
      <mat-label>New Password</mat-label>
      <app-text-field formControlName='password' placeholder='Enter new password' type='password'></app-text-field>
      <div *ngIf='hasControlErrors(password)' class='alert alert-danger'>
        <div *ngIf='password.errors.required'>
          <p class='mb-0'>Password is required.</p>
        </div>
        <div *ngIf='password.errors.minlength'>
          <p class='mb-0'>Password must be at least 8 characters long.</p>
        </div>
        <div *ngIf='password.errors.pattern'>
          <ul>
            <li>Numbers: 0 to 9</li>
            <li>Uppercase Letters: ABC</li>
            <li>Lowercase Letters: abc</li>
            <li>Special Characters: ! @ # $ % & * ( ) _ + - = &#123;} [ ] ; : ' " < > , . ? /</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 d-flex flex-column'>
      <mat-label>Re-enter New Password</mat-label>
      <app-text-field formControlName='password_confirmation' placeholder='Confirm new password'
                      type='password'></app-text-field>
      <div
        *ngIf='hasControlErrors(password_confirmation)'
        class='alert alert-danger'>
        <div *ngIf='password_confirmation.errors.required'>
          <p class='mb-0'>Please, repeat your password</p>
        </div>
        <div *ngIf='password_confirmation.errors.minlength'>
          <p class='mb-0'>Password must be at least 8 characters long.</p>
        </div>
        <div *ngIf='password_confirmation.errors.passwordsDontMatch'>
          <p class='mb-0'>Password didn't match as above</p>
        </div>
      </div>
    </div>
  </div>
</div>
